<template>
  <nav class="navbar is-fixed-top has-shadow" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
       <router-link to="/">
        <img src="@/assets/images/sunset-logo9.png" alt="夕焼け予報" width="160">
       </router-link>
      <!-- <a href="https://7rpn.net" class="navbar-toplink has-text-grey mt-25">
        by 7rpn.net
      </a> -->
      <span class="navbar-toplink has-text-grey mt-25">
        by 7rpn.net
      </span>

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
        data-target="navbarBasicExample" 
        @click="isOpen = !isOpen" v-bind:class="{'is-active': isOpen}">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{'is-active': isOpen}">
      <div class="navbar-start"  @click="isOpen = !isOpen">
        <router-link to="/" class="navbar-item mt-10">
          トップ
        </router-link>

        <router-link to="/about" class="navbar-item mt-10">
          夕焼け予報について
        </router-link>

        <div class="navbar-item has-dropdown is-hoverable mt-10" hidden>
          <a class="navbar-link is-hidden-mobile" @click="isOpen = !isOpen">
            More
          </a>

     
          <div class="navbar-dropdown">
            <!-- <a class="navbar-item" href="https://www.7rpn.net/#/contact" @click="isOpen = !isOpen">
              Contact
            </a> -->
            <!-- <hr class="navbar-divider"> -->
            <a class="navbar-item" href="https://www.7rpn.net/" @click="isOpen = !isOpen">
              作者のページ
            </a>
          </div>
        </div>
      </div>

      <!--
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a class="button is-primary">
              <strong>Sign up</strong>
            </a>
            <a class="button is-light">
              Log in
            </a>
          </div>
        </div>
      </div>
      -->

    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App Header',
      isOpen: false,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.navbar-burger {
}

.navbar-toplink{
  font-family: 'Consolas','Hannotate SC','Menlo',sans-serif;
}
a.navbar-toplink :link {
  color: #0000ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue